import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

function LoadingScreen({ onLoadingComplete }) {
  const [isVisible, setIsVisible] = useState(true);
  const videoRef = useRef(null);

  useEffect(() => {
    // Speed up video playback
    if (videoRef.current) {
      videoRef.current.playbackRate = 1.5; // 1.5x speed
    }

    // Set a minimum display time
    const timer = setTimeout(() => {
      setIsVisible(false);
      // Call the completion callback after fade out animation
      setTimeout(() => {
        onLoadingComplete();
      }, 300); // Faster fade out
    }, 2000); // Reduced to 2 seconds

    return () => clearTimeout(timer);
  }, [onLoadingComplete]);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            overflow: 'hidden'
          }}
        >
          <video
            ref={videoRef}
            autoPlay
            muted
            playsInline
            style={{
              maxWidth: '30%',
              maxHeight: '30%',
              width: 'auto',
              height: 'auto',
              objectFit: 'contain'
            }}
            onEnded={() => {
              // When video ends, start fade out
              setIsVisible(false);
              setTimeout(() => {
                onLoadingComplete();
              }, 300);
            }}
          >
            <source src="/Animated Project Donor Logo (1).mp4" type="video/mp4" />
          </video>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default LoadingScreen;
